var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProcurement = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M13 20.7c-.3 0-.5-.2-.5-.5v-.7h-1.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.4 0 .7-.3.7-.7s-.3-.8-.7-.8h-.8c-1 0-1.7-.8-1.7-1.7 0-.5.2-.9.5-1.2s.7-.5 1.1-.5v-.7c0-.3.2-.5.5-.5s.5.2.5.5v.7h1.1c.3 0 .5.2.5.5s-.2.5-.5.5h-2c-.2 0-.4.1-.5.2s-.2.3-.2.5c0 .4.3.7.7.7h.8c1 0 1.7.8 1.7 1.7s-.7 1.7-1.6 1.7v.7c0 .4-.2.6-.5.6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M21 14.4c-.3 0-.5-.2-.5-.5v-2.8H5.4v2.6c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-3.6l.6.1h16.5l.1.6V14c-.1.2-.3.4-.6.4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M21.5 23.4H4.4V13.3c0-.3.2-.5.5-.5s.5.2.5.5v9.1h15.1v-9.1c0-.3.2-.5.5-.5s.5.2.5.5zM20.9 11.2H4.7l-.2-.3c-.1-.2-.1-.4.1-.6l3-3.8h1.7c.3 0 .5.2.5.5s-.1.4-.4.4H8.1L6 10.2h14.1l-1.8-2.7h-1.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2l2.7 4.1-.3.6z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M12.2 9.6c-.3 0-.5-.2-.5-.5V4.8l-.5.4c-.2.2-.5.2-.7 0s-.2-.5 0-.7l2.1-1.9v6.5c.1.3-.1.5-.4.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M13.5 9.9V3.3c0-.3.2-.5.5-.5s.5.2.5.5v4.4l.5-.4c.2-.2.5-.2.7 0s.2.5 0 .7z"
})));
export default SvgProcurement;